// hooks/usePasswordValidation.ts
import { useState, useEffect } from "react";
import axios from "axios";
import { getCookieValue } from "@utils/helpers";
import { BASE_URL, COUNTRY_CODE } from "@utils/constants";

interface Props {
  eventId: number;
  eventVenueId: number;
  showingId: number;
  initialPassword: string | null;
}

export const usePasswordValidation = ({
  eventId,
  eventVenueId,
  showingId,
  initialPassword,
}: Props) => {
  const [password, setPassword] = useState(initialPassword || "");
  const [passwordStatus, setPasswordStatus] = useState<
    "loading" | "success" | "failure" | "complete" | null
  >(null);

  useEffect(() => {
    const checkShowingPassword = async (pwd: string) => {
      setPasswordStatus("loading");
      let basketKey = getCookieValue("ASP.NET_SessionId");
      const websiteUid = getCookieValue("itk-website-uid");

      if (!basketKey) {
        const session_params = getCookieValue("itk_sessionparams");
        await fetch(`/api/basket`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(session_params ?? ""),
        });

        basketKey = getCookieValue("ASP.NET_SessionId");
      }

      const response = await axios
        .get(
          `${BASE_URL}/legacy/${COUNTRY_CODE}/shop/events/${eventId}/${eventVenueId}/showings/${showingId}/tickets/ga?password=${pwd}`,
          {
            headers: {
              "basket-key": basketKey,
              "itk-website-uid": websiteUid,
            },
          }
        )
        .catch(() => null);

      setPasswordStatus(response ? "success" : "failure");
      if (response) {
        sessionStorage.setItem(`itk_${showingId}_password`, pwd);
      }
      setTimeout(() => setPasswordStatus(response ? "complete" : null), 1000);
    };

    if (password && showingId) {
      checkShowingPassword(password);
    }
  }, [eventId, eventVenueId, showingId, password]);

  return { password, setPassword, passwordStatus };
};
